import styled from 'styled-components';

export default styled.div`
  .ant-row {
    .ant-col {
      margin-bottom: 20px;
    }
  }
`;
